import { MetricCell } from './MetricCell.component';
import { RowTitle } from './RowTitle.component';
import { ForecastParamCode } from 'pleinchamp-api-client';
import { useSelector } from 'react-redux';
import { PlcTextListLoader } from '@components/Loaders/PlcTextLoader.component';
import { userSelectors } from '@user/business/User.store';
import { MetricsType, MetricsType24H } from '../../utils';

interface Props {
  metric?: MetricsType | MetricsType24H;
  isLoading?: boolean;
  is15Days?: boolean;
  is36h?: boolean;
  hoveredIndex?: number;
  onMouseEnter: (index: number) => void;
}

function MetricRow({ metric, isLoading, is15Days, is36h, hoveredIndex, onMouseEnter }: Props) {
  const isPro = useSelector(userSelectors.isPro);
  if (!metric) {
    return null;
  }

  const isDecimal =
    metric.key === 'precipitationAmountInMillimeter' ||
    metric.key === 'maxPrecipitationAmountInMillimeter' ||
    metric.key === 'evaporationMakkinkInMillimeter';
  const isMoonPhase = metric.key === 'moonPhase';

  return (
    <tr key={metric.key}>
      <th>
        {isLoading ? (
          <PlcTextListLoader
            fixedWidth
            textProps={[{ variant: 'h5', width: 140 }]}
            uniqueKey={`metricRow-${metric.key}`}
          />
        ) : (
          <RowTitle forecastParam={metric.key as ForecastParamCode} is15Days={is15Days} is36h={is36h} isPro={isPro} />
        )}
      </th>
      <td className="table-navigation left" />

      {metric.data.map((d, i) => (
        <MetricCell
          // eslint-disable-next-line react/no-array-index-key
          key={`${metric.key}-${i}`}
          data={d}
          emphasis={i === hoveredIndex}
          isDecimal={isDecimal}
          isLoading={isLoading}
          isMoonPhase={isMoonPhase}
          onMouseEnter={() => onMouseEnter(i)}
        />
      ))}

      <td className="table-navigation right" />
    </tr>
  );
}

export { MetricRow };
